import axios from "axios";
import { getRequest, postRequest, putRequest } from "../services/apiHelpers";

export const postUser = async (payload) => {
  try {
    const res = await postRequest({ url: "/users", payload: payload });
    return res;
  } catch (e) {
    throw e;
  }
};

export const putUser = async ({ id, payload }) => {
  try {
    const res = await putRequest({
      url: "/users",
      payload: payload,
      query: { user_id: id },
    });
    return res;
  } catch (e) {
    throw e;
  }
};

export const getUsers = async (query) => {
  try {
    const res = await getRequest({
      url: "/users",
      query: query,
    });
    return res;
  } catch (e) {
    throw e;
  }
};
